import React  from 'react';
import Buildings from 'components/Buildings'

function Cotteges(props) {
  return (
    <Buildings {...props} isCottegesPage />
  );
}

export default Cotteges;



// WEBPACK FOOTER //
// ./src/components/Cotteges/Cotteges.js